import { lazy } from 'react'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'

const Inner = lazy(() => import('./Inner'))

/**
 * Hosts the document dialogs that may be invoked from anywhere else in the
 * app.
 */
export const DocumentDialogsHost = observer(function DocumentDialogsHost() {
  const { isDocumentsRequested } = useFeatures((r) => ({
    isDocumentsRequested: r.documents.internal.isRequested,
  }))

  // Rendering the dialogs loads the feature, so wait until something else has.
  if (!isDocumentsRequested()) {
    return null
  }

  return <Inner />
})
